import React, {useEffect, useState} from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {Box} from "@mui/material";
import { useMediaQuery, Drawer } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from '@mui/material/styles';
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SuiButton from "components/SoftButton";
import {MdRssFeed} from "react-icons/md";
import {IoIosAdd} from "react-icons/io";
import DashboardLayout from "reusableComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "reusableComponents/Navbars/DashboardNavbar";
import Footer from "reusableComponents/Footer";
import CardComponent from "reusableComponents/Tables/Card";
import {createArticle, getDigitizations, getArchivesById, getUserDocuments} from "axios-client";
import data from '../../constants/languages.json';

import { formatDataToUrlQueryParams} from "utlis/generalUtils";
import DigitizeArticleDialog from "./DigitizeArticleDialog";
import {digitize, getSubjects} from "../../axios-client";

import SnackbarNotification from "../../reusableComponents/Snackbar/SnackbarNotification";
import {useSoftUIController} from "../../context";
import {FREE_AGENT, PUBLICATIONS_VIEW, USER_PUBLICATIONS_VIEW, ALMANDUMA_CUSTOMER} from "../../utlis/constant";
import FilterList from "./FilterList";
import FilterListIcon from '@mui/icons-material/FilterList';
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";


const publications = ({view}) => {

    // State declarationss
    const [controller] = useSoftUIController();
    const {role, userId} = controller;
    const rolesAllowed = ['librarian', 'free-agent'];
    const [rows, setRows] = useState([]);
    const [articleCount, setArticleCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentFilter, setCurrentFilter] = useState("All Fields");
    const [searchText, setSearchText] = useState("");
    const [notification, setNotification] = useState({
        show: false,
        snackbarMessage: "",
        severity: "",

    });
    const [filterData, setFilterData] = useState({
        page: 1,
        size: 10,
        Title: "",
        Author: "",
        Email: "",
        Date: "",
        Subjects: "",
        subjects: "",
        languages: "",
        all_fields: "",
    });


    const [isDigitizing, setIsDigitizing] = useState(false);
    const [openDigitizerDialog, setOpenDigitizerDialog] = useState(false);

    const [languages, setLanguages] = useState([]);
    const [subjects, setSubjects] = useState([]);

    const [searchSubjectTerm, setSearchSubjectTerm] = useState("");
    const [selectedSubjects, setSelectedSubjects] = useState([]);

    const [searchLanguageTerm, setSearchLanguageTerm] = useState("");
    const [selectedLanguages, setSelectedLanguages] = useState([]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

    const [subjectCollapsed, setSubjectCollapsed] = useState(isMobile ? false : false);
    const [languageCollapsed, setLanguageCollapsed] = useState(isMobile ? true : false);
    const [filterCollapsed, setFilterCollapsed] = useState(true);
    const [email, setEmail] = useState("");
    const isAlmandumahCustomer = (window?.appConfig?.REACT_APP_CUSTOMER_NAME || process.env.REACT_APP_CUSTOMER_NAME) === ALMANDUMA_CUSTOMER


    const { t, i18n } = useTranslation("myDocuments");
    const dir = i18n.dir();
    const currentLanguage = i18n.language;



    // Data fetching function
    const refreshList = () => {
        const queryParams = formatDataToUrlQueryParams(filterData);
        if (view === USER_PUBLICATIONS_VIEW) {
            fetchUserPublicationsData(`?${queryParams}`);
        } else {
            fetchData(`?${queryParams}`);
        }
    }

    // Effect hook to fetch data when filterData changes
    useEffect(() => {
        refreshList()
    }, [filterData, view]);


    useEffect(() => {
        setLanguages(
            data.map(lang => ({
                ...lang,
                language: i18n.language === 'ar'
                    ? lang.language_ar || lang.language
                    : lang.language
            }))
        );
        getSubjects(currentLanguage)
            .then(res => {
                setSubjects(res.data);
            })
            .catch(error => {
                console.error('Error fetching subjects:', error);
            });
        if (selectedSubjects.length != 0 || selectedLanguages.length != 0) {
            handleClearAll();
        }
    }, [currentLanguage]);



    const fetchUserPublicationsData = (params) => {
        setLoading(true);
        setError(null);

        getUserDocuments(params)
            .then((res) => {
                const formattedRows = res.data.data
                    ? res.data.data.map((archive) => ({
                        id: archive.id,
                        picture_path: archive.article.picture_path,
                        title: archive.article.title,
                        batch_name: archive.batch_name,
                        subjects: archive.article.subjects,
                        author: archive.article.author,
                        summary: archive.summary,
                        source_language: archive.article.source_language,
                        target_language: archive.article.target_language,
                        publishedAt: archive.article.publication_date,
                        status: archive.status,
                        services_data: archive.services_data,
                        totalApproximativeTime: archive.total_approximative_time,
                        digitizationStartedAt: archive.digitization_started_at,
                        all_services_selected: archive.all_services_selected,
                        createdAt: archive.article.created_at,
                        bookmarking_path: archive.article.bookmarking_path,
                        articleId: archive.article.id,
                        digitizerId:archive.article.user_id,
                        has_audio_option:archive.article.has_audio_option,
                        digitization_results: archive.digitization_results,
                    }))
                    : [];
                setArticleCount(res.data.count);
                setRows(formattedRows);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching archives:", error);
                setError("Failed to load data. Please try again.");
                setLoading(false);
            });
    };


    const fetchData = (params) => {
        setLoading(true);
        setError(null);

        getDigitizations(`${params}&lang=${currentLanguage}`)
            .then((res) => {
                const formattedRows = res.data.data
                    ? res.data.data.map((archive) => ({
                        id: archive.id,
                        picture_path: archive.article.picture_path,
                        totalApproximativeTime: archive.total_approximative_time,
                        digitizationStartedAt: archive.digitization_started_at,
                        title: archive.article.title,
                        batch_name: archive.batch_name,
                        subjects: archive.article.subjects,
                        author: archive.article.author,
                        summary: archive.summary,
                        publishedAt: archive.article.publication_date,
                        status: archive.status,
                        services_data: archive.services_data,
                        digitization_results: archive.digitization_results,
                        all_services_selected: archive.all_services_selected,
                        createdAt: archive.article.created_at,
                        origin: archive.article.origin,
                        bookmarking_path: archive.article.bookmarking_path,
                        articleId: archive.article.id,
                        cost: archive.article.cost,
                        source_language: archive.article.source_language,
                        target_language: archive.article.target_language,
                        digitizerId:archive.article.user_id,
                        has_audio_option:archive.article.has_audio_option
                    }))
                    : [];
                setArticleCount(res.data.count);
                setRows(formattedRows);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching archives:", error);
                setError("Failed to load data. Please try again.");
                setLoading(false);
            });
    };

    const getArchivesBySelectedDocument = async (id) => {
        try {
            const res = await getArchivesById(id);
            let data = res.data.data;
            return {
                details: {
                    Digitization_date: data.article.created_at,
                    Number_of_pages: data.article.page_count,
                    Document_ID: data.id,
                },
                title: data.article.title,
                author: data.article.author,
                filename: data.article.filename,
                extension: data.article.extension,
                publishedAt: data.article.publication_date,
                picture_path: data.article.picture_path,
                ocr_text: data.ocr_text,
                translated_text: data.translated_text,
                summary: data.summary,
                bullet_points_summary: data.bullet_points_summary,
                description: data.description,
                bookmarking_path: data.bookmarking_path,
                searchable_pdf_path: data.searchable_pdf_path,
                cost: data.article.cost,
            };
        } catch (error) {
            console.error("Error fetching archives by id:", error);
        }
    };

    // Handle search input change
    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    // Handle Enter key press in search input
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearchSubmit();
        }
    };

    // Handle search submission
    const handleSearchSubmit = () => {

        // Map the current filter to the corresponding key in filterData
        let filterKeyMap = {
            "All Fields": "all_fields",
            Title: "title",
            Author: "author",
            Date: "date",
            Language: "language",
            Subjects: "subject",
        };

        if (view === USER_PUBLICATIONS_VIEW) {
            filterKeyMap = {
                researcher_id: "researcher_id",
                ...filterKeyMap,
            };
        }

        const filterKey = filterKeyMap[currentFilter] || "all_fields";

        setFilterData(prev => ({
            ...prev,
            [filterKey]: searchText.trim(),
            ...(view === USER_PUBLICATIONS_VIEW && { researcher_id: userId })
        }));

    };

    // Handle filter selection change
    const handleFilterChange = (event) => {
        setCurrentFilter(event.target.value);
    };

    // Pagination handlers
    const handlePageChange = (newPage) => {
        setFilterData((prev) => ({...prev, page: newPage}));
    };

    const handleRowsPerPageChange = (newSize) => {
        setFilterData((prev) => ({...prev, size: newSize, page: 1}));
    };

    // Functions for digitizing articles
    const handleOpenDialog = () => {
        setOpenDigitizerDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDigitizerDialog(false);
    };



    const handleDigitizeArticle = (data) => {
        setIsDigitizing(true);
        digitize(data)
            .then((response) => {
                setNotification({
                    show: true,
                    snackbarMessage: t("articleCreatedSuccessfully"),
                    severity: "success",
                });
                setOpenDigitizerDialog(false);
                setIsDigitizing(false);
                setFilterData({...filterData, page: 1});
            })
            .catch((error) => {
                setIsDigitizing(false);
                setNotification({
                    show: true,
                    snackbarMessage: t("digitizeError"),
                    severity: "error",
                });
            });
    };

    const handleCreateArticle = (data) => {
        setIsDigitizing(true);
        createArticle(data)
            .then((response) => {
                setNotification({
                    show: true,
                    snackbarMessage: t("articleCreatedSuccessfully"),
                    severity: "success",
                });
                setOpenDigitizerDialog(false);
                setIsDigitizing(false);
                setFilterData({...filterData, page: 1});
            })
            .catch((error) => {
                setIsDigitizing(false);
                setNotification({
                    show: true,
                    snackbarMessage: t("digitizeError"),
                    severity: "error",
                });
            });
    };

    const handleEmailChange = (email) => {
        setEmail(email)
        setFilterData({...filterData, email: email});
    };

    const handleCheckboxSubjectChange = (label) => {
        let updatedSubjects;
        let updatedItems;
        if (selectedSubjects.some(item => item.id === label.id)) {
            updatedSubjects = selectedSubjects.filter(item => item.id !== label.id);
        } else {
            updatedSubjects = [...selectedSubjects, label];
        }
        updatedItems = updatedSubjects.map(item => item.id);
        setSelectedSubjects(updatedSubjects);
        setFilterData({ ...filterData, subjects: updatedItems.join(', ') });
    };

    const handleCheckboxLanguageChange = (label) => {
        let updatedLanguages;
        let updatedItems
        if (selectedLanguages.some(item => item.id === label.id)) {
            updatedLanguages = selectedLanguages.filter(item => item.id !== label.id);
        } else {
            updatedLanguages = [...selectedLanguages, label]
        }
        updatedItems = updatedLanguages.map(item => item.id);
        setSelectedLanguages(updatedLanguages);
        setFilterData({...filterData, languages: updatedItems.join(', ')});
    };

    const handleSubjectCollapseToggle = () => {
        if (subjectCollapsed) {
            // If subject filter is collapsed, expand it and collapse languages.
            setSubjectCollapsed(false);
            setLanguageCollapsed(true);
        } else {
            // If it's already open, collapse it (optional behavior).
            setSubjectCollapsed(true);
        }
    };

    const handleLanguageCollapseToggle = () => {
        if (languageCollapsed) {
            // If language filter is collapsed, expand it and collapse subjects.
            setLanguageCollapsed(false);
            setSubjectCollapsed(true);
        } else {
            setLanguageCollapsed(true);
        }
    };

    const handleFilterCollapseToggle = () => {
        setFilterCollapsed(!filterCollapsed);
    };


    const handleClearAll = () => {
        setSelectedSubjects([]);
        setSelectedLanguages([]);
        setEmail("")
        setFilterData({...filterData, subjects: "", languages: "", email: ""})
    };


    const handleCloseDrawer = () => {
        setFilterDrawerOpen(false);
    };

    const handleFilterToggle = () => {
        if (isMobile) {
            setFilterDrawerOpen(!filterDrawerOpen);
        } else {
            handleFilterCollapseToggle();
        }
    };


    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <SoftBox py={2} style={{minHeight: "630px"}}>
                <SoftBox mb={2}>
                    {/* Search and Filter Section */}
                    <SoftBox mb={0.5} sx={{marginRight: '8px', marginLeft: '8px', paddingTop: "30px"}}>
                        <Grid container justifyContent="center">
                            <Grid item xs={12}>
                                <Box display="flex" flexDirection={{xs: 'column', sm: 'row'}}
                                     gap={1}
                                     alignItems={{xs: 'stretch', sm: 'center'}}>
                                    {/* Search Input */}
                                    <Box sx={{flexGrow: 1, width: '100%'}}>
                                        <TextField
                                            variant="outlined"
                                            placeholder={t("searchPlaceholder")}
                                            value={searchText}
                                            onChange={handleSearchChange}
                                            onKeyDown={handleKeyDown}
                                            fullWidth
                                            InputProps={{
                                                sx: {
                                                    '& input': {
                                                        width: '100% !important',
                                                        minWidth: 0,
                                                        maxWidth: '100%',
                                                    }
                                                }
                                            }}
                                        />
                                    </Box>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            width: {xs: '100%', sm: 'auto'},
                                            mt: {xs: 1, sm: 0}
                                        }}
                                    >

                                    {/* 'Filter By' Dropdown */}
                                    <Box sx={{flexGrow: {xs: 1, sm: 0}}}>
                                        <Select
                                            value={currentFilter}
                                            onChange={handleFilterChange}
                                            displayEmpty
                                            variant="outlined"
                                            inputProps={{"aria-label": t("filterByAriaLabel")}}
                                            fullWidth={isMobile}
                                            sx={{
                                                minWidth: {sm: 150}
                                            }}
                                        >
                                            <MenuItem value="All Fields">{t("allFields")}</MenuItem>
                                            <MenuItem value="Title">{t("title")}</MenuItem>
                                            <MenuItem value="Author">{t("author")}</MenuItem>
                                            <MenuItem value="Date">{t("date")}</MenuItem>
                                            <MenuItem value="Subjects">{t("subjects")}</MenuItem>
                                        </Select>
                                    </Box>
                                    {/* Search Button */}
                                    <Box>
                                        <IconButton onClick={handleSearchSubmit} color="primary">
                                            <SearchIcon/>
                                        </IconButton>
                                    </Box>
                                </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </SoftBox>

                    {/* Results Header and Action Button */}
                    <SoftBox
                        display="flex"
                        flexDirection={{xs: 'column', sm: 'row'}}
                        justifyContent="space-between"
                        alignItems={{xs: 'flex-start', sm: 'center'}}
                        gap={1}
                        p={1}
                        style={{paddingTop: "16px", paddingBottom: "16px"}}
                    >
                        <SoftTypography variant="h6" sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            fontSize: {xs: '1.1rem', sm: '1.25rem'}
                        }}>
                            <span>{t("results")} : {articleCount}</span>
                            <MdRssFeed style={{marginLeft: '4px'}}/>

                            {view === PUBLICATIONS_VIEW && <Tooltip title={t("filterTooltip")}>
                                <FilterListIcon
                                    sx={{
                                        fontSize: {xs: '1.8rem', sm: '2.5rem'},
                                        cursor: 'pointer',
                                        marginLeft: '10px',
                                        display: 'inline-flex' // Ensure it always shows
                                    }}
                                    onClick={handleFilterToggle}
                                />
                            </Tooltip>}

                        </SoftTypography>

                        {!isAlmandumahCustomer && rolesAllowed.includes(role) && view === PUBLICATIONS_VIEW && (<SuiButton
                            variant="gradient"
                            color="primary"
                            size="small"
                            sx={{
                                width: {xs: '100%', sm: 'auto'},
                                marginTop: {xs: 1, sm: 0}
                            }}
                            onClick={handleOpenDialog}
                        >
                            <IoIosAdd/>{t("digitizeNewDocument")}
                        </SuiButton>)}
                    </SoftBox>

                    {/* Error Message */}
                    {error && (
                        <SoftBox mb={2}>
                            <SoftTypography color="error">{error}</SoftTypography>
                        </SoftBox>
                    )}

                    {/* Filter List and Results Area */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: {xs: 'column', md: 'row'},
                            gap: 2
                        }}
                    >
                        {/* Desktop Filter Panel - only show on non-mobile when not collapsed */}
                        {!isMobile && (
                            <FilterList
                                filterCollapsed={filterCollapsed}
                                handleFilterCollapseToggle={handleFilterCollapseToggle}
                                selectedSubjects={selectedSubjects}
                                selectedLanguages={selectedLanguages}
                                handleCheckboxSubjectChange={handleCheckboxSubjectChange}
                                handleCheckboxLanguageChange={handleCheckboxLanguageChange}
                                handleClearAll={handleClearAll}
                                searchSubjectTerm={searchSubjectTerm}
                                setSearchSubjectTerm={setSearchSubjectTerm}
                                searchLanguageTerm={searchLanguageTerm}
                                setSearchLanguageTerm={setSearchLanguageTerm}
                                subjects={subjects}
                                languages={languages}
                                emailValue={filterData.email}
                                email={email}
                                setEmail={setEmail}
                                handleEmailChange={handleEmailChange}
                                clearEmail={() => setFilterData({...filterData, email: ""})}
                                subjectCollapsed={subjectCollapsed}
                                handleSubjectCollapseToggle={handleSubjectCollapseToggle}
                                languageCollapsed={languageCollapsed}
                                handleLanguageCollapseToggle={handleLanguageCollapseToggle}
                                isDrawerMode={false}
                            />
                        )}

                        {/* Results Area */}
                        {loading ? (
                            <SoftBox
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight="200px"
                                width="100%"
                                flexGrow={1}
                            >
                                <SoftTypography>{t("loading")}</SoftTypography>
                            </SoftBox>
                        ) : (
                            <SoftBox
                                sx={{
                                    width: '100%',
                                    flexGrow: 1
                                }}
                            >
                                <Grid container>
                                    <Grid item xs={12}>
                                        <CardComponent
                                            data={rows}
                                            count={articleCount}
                                            size={filterData.size}
                                            page={filterData.page}
                                            handlePageChange={handlePageChange}
                                            handleRowsPerPageChange={handleRowsPerPageChange}
                                            loadingData={loading}
                                            getArchivesBySelectedDocument={getArchivesBySelectedDocument}
                                            setNotification={setNotification}
                                            searchText={searchText}
                                            refreshList={refreshList}
                                            view={view}
                                        />
                                    </Grid>
                                </Grid>
                            </SoftBox>
                        )}
                    </Box>

                </SoftBox>
            </SoftBox>

            <Drawer
                anchor="right"
                open={isMobile && filterDrawerOpen}
                onClose={handleCloseDrawer}
                PaperProps={{
                    sx: {
                        width: '80%',
                        maxWidth: '350px',
                        borderTopLeftRadius: isMobile ? '16px' : 0,
                        borderBottomLeftRadius: isMobile ? '16px' : 0
                    }
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2,
                    borderBottom: '1px solid rgba(0,0,0,0.12)'
                }}>
                    <SoftTypography variant="h6">{t("filterTooltip")}</SoftTypography>
                    <IconButton onClick={handleCloseDrawer}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ overflow: 'auto', height: 'calc(100% - 56px)' , padding:'10px'}}>
                    <FilterList
                        filterCollapsed={false}
                        handleFilterCollapseToggle={handleCloseDrawer}
                        selectedSubjects={selectedSubjects}
                        selectedLanguages={selectedLanguages}
                        handleCheckboxSubjectChange={handleCheckboxSubjectChange}
                        handleCheckboxLanguageChange={handleCheckboxLanguageChange}
                        handleClearAll={handleClearAll}
                        searchSubjectTerm={searchSubjectTerm}
                        setSearchSubjectTerm={setSearchSubjectTerm}
                        searchLanguageTerm={searchLanguageTerm}
                        setSearchLanguageTerm={setSearchLanguageTerm}
                        subjects={subjects}
                        languages={languages}
                        emailValue={filterData.email}
                        email={email}
                        setEmail={setEmail}
                        handleEmailChange={handleEmailChange}
                        clearEmail={() => setFilterData({...filterData, email: ""})}
                        subjectCollapsed={subjectCollapsed}
                        handleSubjectCollapseToggle={handleSubjectCollapseToggle}
                        languageCollapsed={languageCollapsed}
                        handleLanguageCollapseToggle={handleLanguageCollapseToggle}
                        isDrawerMode={true}
                    />
                </Box>
            </Drawer>
            <Footer/>

            {/* Digitize Article Dialog */}
            {openDigitizerDialog && (
                <DigitizeArticleDialog
                    open={openDigitizerDialog}
                    isDigitizing={isDigitizing}
                    onClose={handleCloseDialog}
                    handleDigitizeArticle={role == FREE_AGENT ? handleCreateArticle : handleDigitizeArticle}

                />
            )}

            {/* Snackbar Notification */}
            <SnackbarNotification
                notification={notification}
                setNotification={setNotification}
            />
        </DashboardLayout>
    );
};

export default publications;
